import { forwardRef, FC, useState, useEffect } from 'react';
// Models
import { IOption_V2 } from 'app/models/Option';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectEpisodeTypesAsOptions } from 'app/store/Episodes/Episodes.selectors';
// Mui
import { Chip, Autocomplete, TextField } from '@mui/material';
// i18next
import { useTranslation } from 'react-i18next';
// Utilities
import { generateAttrForTesting } from 'app/utilities/Utilities';

type Props = {
  value: string[];
  onChange: (nextValue:any[]) => void;

  size?: any;
  margin?: any;
}

const AutocompleteTypes:FC<Props> = forwardRef(({
  // Props
  value, onChange, size, margin = 'normal'
}, ref) => {
  const { t } = useTranslation();
  // State
  const options = useAppSelector((state:any) => selectEpisodeTypesAsOptions(state));

  const [ selectedOptions, setSelectedOptions ] = useState<IOption_V2[]>([]);

  // useEffect(() => {
  //   return () => {
  //     setSelectedOptions([]);
  //   }
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    if ( value.length && options ){
      const filteredOptions = options.filter((option:any) => value.includes(option.value));
      setSelectedOptions(filteredOptions);
    } else {
      setSelectedOptions([]);
    }
    // eslint-disable-next-line
  }, [value]);

  const handleChange = (_:any, nextValue:any[] | undefined) => {
    setSelectedOptions(nextValue || []);
    onChange(nextValue ? nextValue.map((option:IOption_V2) => option.value) : []);
  }

  return (
    <Autocomplete
      {...generateAttrForTesting('control', 'autocomplete', 'types')}
      value={selectedOptions}
      onChange={handleChange}
      options={options || []}
      size={size}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('labels.types')}
          margin={margin}
          fullWidth
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>{option.label}</li>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            sx={{ maxWidth: '160px' }}
            key={option.value}
            label={option.label}
            title={option.label}
            size={size}
          />
        ))
      }
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      fullWidth
      multiple
      limitTags={3}
      filterSelectedOptions

      ListboxProps={{...generateAttrForTesting('element', 'list', 'types')}}
    />
  )
})

export default AutocompleteTypes;
